import { Component } from '@angular/core';
import { ConfirmModalService } from 'src/app/core/services/confirm-modal.service';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent {

  show = false;
  title = '';
  message = '';
  loading = false;

  confirmText = 'Confirm';
  cancelText = 'Cancel';

  private onConfirmCallback!: () => void;

  constructor(private confirmModalService: ConfirmModalService) { }

  ngOnInit() {
    this.confirmModalService.modalState.subscribe((data) => {

      this.show = data.show;

      if (data.show) {
        this.title = data.title;
        this.message = data.message;
        this.confirmText = data.confirmText;
        this.cancelText = data.cancelText;
        this.onConfirmCallback = data.onConfirm;
      }
    });
  }

  confirm() {
    if (this.onConfirmCallback) {
      this.onConfirmCallback();
    }
    this.close();
  }

  close() {
    this.show = false;
  }
}